// extracted by mini-css-extract-plugin
export default {"ProfileInfoContainer":"ProfileInfo_ProfileInfoContainer__RdpZC","info":"ProfileInfo_info__PxG-1","title":"ProfileInfo_title__hqBL-"};